import React from "react";
import {
  Class,
  JSTypeOperator,
  ObjectTypes,
} from "../../../../GenericCoreGraph/ClassFramework/Class";
import Typography from "@material-ui/core/Typography";
import TBaseDialogModal from "../../../Utilities/TBaseDialogModal";
import { DialogActions } from "@material-ui/core";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import Chip from "@material-ui/core/Chip";
import Button from "@material-ui/core/Button";

var TTagsModal = Class(
  TBaseDialogModal,
  {
    ObjectType: ObjectTypes.Get("TTagsModal"),
    constructor: function (_Props) {
      TTagsModal.BaseObject.constructor.call(this, _Props);
      this.state = {
        ...this.state,
        open: false,
        title: null,
        allTags: [],
      };
      window.App.TagsModal = this;
    },
    AsycLoad: function () {
      var __This = this;
      __This.HandleGetTemplateDetail();
    },
    Destroy: function () {
      TTagsModal.BaseObject.Destroy.call(this);
    },
    HandleClickOpen: function (_ParamObject, _CallbackOnClose) {
      TTagsModal.BaseObject.HandleClickOpen.call(
        this,
        _ParamObject,
        _CallbackOnClose
      );
      this.CallbackOnClose = _CallbackOnClose;
      this.setState({
        open: true,
        allTags: _ParamObject.AllTags,
        title: _ParamObject.Title,
      });
    },
    HandleClose: function () {
      this.setState({
        open: false,
      });

      if (JSTypeOperator.IsFunction(this.CallbackOnClose)) {
        var __Function = this.CallbackOnClose;
        this.CallbackOnClose = null;
        __Function();
      }
    },
    HandleGetSize: function () {
      return "sm";
    },
    render: function () {
      var __This = this;
      var __Params = TTagsModal.BaseObject.render.call(this);
      if (!__Params.NeedRender) {
        return null;
      }
      return this.HandleWrapModal(
        <div>
          <DialogTitle>
            <Grid container>
              <Grid item xs={11}>
                <Typography variant={"h5"}>{__This.state.title}</Typography>
              </Grid>
              <Grid item xs={11} />
            </Grid>
          </DialogTitle>
          <DialogContent dividers>
            <Grid container spacing={2}>
              {__This.state.allTags.map((_Item, _Index) => {
                var __LinkUrl =
                  "/" + window.Pages.Names.SearchPage + "?ss=" + _Item.Tag;
                return (
                  <Grid item>
                    <Chip
                      key={_Item.ID}
                      label={_Item.Tag}
                      color="primary"
                      clickable
                      onClick={()=>{
                        __This.HandleClose();
                        GenericWebGraph.GoPage(__LinkUrl);
                      }}
                    />
                  </Grid>
                );
              })}
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant={"contained"}
              onClick={this.HandleClose}
            >
              {this.state.Language.Close}
            </Button>
          </DialogActions>
        </div>
      );
    },
  },
  {}
);

export default TTagsModal;
